// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.inftimeline {
    padding: 0 0.25em 0.25em 0.25em;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
}

div.inftimeline-toolbar {
    display: flex;
    font-size: 75%;
    align-items: center;
    flex: 0 0 auto;
}

div.inftimeline-toolbar-block {
    margin-left: 1em;
    display: flex;
    align-items: center;
}

div.inftimeline-toolbar-block > input,
div.inftimeline-toolbar-block > div.ToggleSwitch
 {
    width: 6em;
}

div.inftimeline-toolbar-spacer {
    flex: 1 1 auto;
}

div.inftimeline-clip {
    overflow: hidden;
    position: relative;
    flex: 0 0 auto;
}

div.inftimeline-ticks {
    margin: 2em 0.25em 0 0.25em;
    position: relative;
    height: 10px;
}


div.inftimeline-ticks > span.inftimeline-ltick {
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 100%;
    background-color: black;
}

div.inftimeline-ticks > span.inftimeline-ltick > span {
    position: absolute;
    width: 10em;
    text-align: center;
    white-space: pre;
    font-size: 70%;
    left: -5em;
    top: -2.5em;
}

div.inftimeline-ticks > span.inftimeline-tick {
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 50%;
    bottom: 0;
    background-color: gray;
}

button.inftimeline-pan-left,
button.inftimeline-pan-right {
    position: absolute;
    bottom: 0;
    top: 0;
    width: 1.5em;
    height: initial;
    z-index: 1;
}

button.inftimeline-pan-left:disabled,
button.inftimeline-pan-right:disabled {
    color: var(--text-color-disabled);
}


button.inftimeline-pan-left {
    left: 0;
}

button.inftimeline-pan-right {
    right: 0;
}
`, "",{"version":3,"sources":["webpack://./../qwc2/components/timeline/style/InfiniteTimeline.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,SAAS;IACT,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;;IAEI,iCAAiC;AACrC;;;AAGA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ","sourcesContent":["div.inftimeline {\n    padding: 0 0.25em 0.25em 0.25em;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-color);\n}\n\ndiv.inftimeline-toolbar {\n    display: flex;\n    font-size: 75%;\n    align-items: center;\n    flex: 0 0 auto;\n}\n\ndiv.inftimeline-toolbar-block {\n    margin-left: 1em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.inftimeline-toolbar-block > input,\ndiv.inftimeline-toolbar-block > div.ToggleSwitch\n {\n    width: 6em;\n}\n\ndiv.inftimeline-toolbar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.inftimeline-clip {\n    overflow: hidden;\n    position: relative;\n    flex: 0 0 auto;\n}\n\ndiv.inftimeline-ticks {\n    margin: 2em 0.25em 0 0.25em;\n    position: relative;\n    height: 10px;\n}\n\n\ndiv.inftimeline-ticks > span.inftimeline-ltick {\n    position: absolute;\n    display: inline-block;\n    width: 2px;\n    height: 100%;\n    background-color: black;\n}\n\ndiv.inftimeline-ticks > span.inftimeline-ltick > span {\n    position: absolute;\n    width: 10em;\n    text-align: center;\n    white-space: pre;\n    font-size: 70%;\n    left: -5em;\n    top: -2.5em;\n}\n\ndiv.inftimeline-ticks > span.inftimeline-tick {\n    position: absolute;\n    display: inline-block;\n    width: 2px;\n    height: 50%;\n    bottom: 0;\n    background-color: gray;\n}\n\nbutton.inftimeline-pan-left,\nbutton.inftimeline-pan-right {\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    width: 1.5em;\n    height: initial;\n    z-index: 1;\n}\n\nbutton.inftimeline-pan-left:disabled,\nbutton.inftimeline-pan-right:disabled {\n    color: var(--text-color-disabled);\n}\n\n\nbutton.inftimeline-pan-left {\n    left: 0;\n}\n\nbutton.inftimeline-pan-right {\n    right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
